import { Reveal } from "@/components/site/Reveal";
import { Overline } from "@/components/site/primitives";
import { LogoMark } from "@/components/site/Logo";
import NewsletterForm from "@/components/site/NewsletterForm";

export default function StayInLoop() {
  return (
    <section id="stay-in-the-loop" className="scroll-mt-24 bg-rp-bg" data-testid="stay-in-loop">
      <div className="mx-auto max-w-7xl px-6 pb-24 md:px-12 md:pb-32">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-rp-surface p-8 md:p-16">
          <div className="pointer-events-none absolute -right-16 -top-16 opacity-[0.06] md:opacity-10">
            <LogoMark size={340} />
          </div>
          <div className="relative grid gap-10 md:grid-cols-2 md:items-center">
            <div>
              <Overline>Stay in the Loop</Overline>
              <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl">
                Stay in the Loop
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-white/55">
                Be among the first to hear about RestPower updates, future locations, and our journey
                toward building a better charging experience.
              </p>
            </div>
            <Reveal delay={0.1}>
              <NewsletterForm />
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
